module.exports = __webpack_public_path__ + "img/nuxt-logo.74e8b3b.png";